import { render, staticRenderFns } from "./ShopContact.vue?vue&type=template&id=7c16c131&scoped=true"
import script from "./ShopContact.vue?vue&type=script&lang=js"
export * from "./ShopContact.vue?vue&type=script&lang=js"
import style0 from "./ShopContact.vue?vue&type=style&index=0&id=7c16c131&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c16c131",
  null
  
)

export default component.exports